/**
 * Do not edit directly
 * Generated on Fri, 12 Nov 2021 14:42:51 GMT
 */
export var aliasActionBorderRadius = "2px";
export var aliasBackdropColorBase = "#000000";
export var aliasBackdropOpacityBase = 0.73;
export var aliasFocusColor = "#92d3ee";
export var aliasFocusColorError = "#f97a7d";
export var aliasFocusWidth = "3px";
export var aliasFocusBoxShadow = "0 0 0 3px #92d3ee";
export var aliasFocusBoxShadowError = "0 0 0 3px #f97a7d";
export var aliasFocusRingColorBase = "#92d3ee";
export var aliasFocusRingColorError = "#f97a7d";
export var aliasFocusRingSizeBase = "3px";
export var aliasInputBorderWidth = "1px";
export var aliasInputBorderRadius = "4px";
export var aliasInputBorderColor = "#919191";
export var aliasInputBorderColorHover = "#0a3142";
export var aliasInputBorderColorError = "#e92326";
export var aliasInputBorderColorActive = "#000000";
export var aliasInputBorderColorFocus = "#919191";
export var aliasInputBorderColorDisabled = "#d7d7d7";
export var aliasInputBorderColorChecked = "#0a3142";
export var aliasInputBackgroundColor = "#ffffff";
export var aliasInputBackgroundColorError = "#e92326";
export var aliasInputBackgroundColorActive = "#062430";
export var aliasInputBackgroundColorFocus = "#0a3142";
export var aliasInputBackgroundColorDisabled = "#ededed";
export var aliasInputBackgroundColorChecked = "#0a3142";
export var aliasInputTextColorChecked = "#ffffff";
export var aliasInputBoxShadow = "0 2px 4px rgba(0, 0, 0, .12)";
export var aliasInputBoxShadowActive = "inset 0 1px 5px 0 #000000";
export var aliasInputBoxShadowFocus = "0 0 0 3px #92d3ee";
export var aliasInputBoxShadowError = "0 0 0 3px #f97a7d";
export var aliasFieldBorderWidthBase = "1px";
export var aliasFieldBorderColorBase = "#919191";
export var aliasFieldBorderColorHover = "#0a3142";
export var aliasFieldBorderColorError = "#e92326";
export var aliasFieldBorderColorActive = "#000000";
export var aliasFieldBorderColorFocus = "#919191";
export var aliasFieldBorderColorDisabled = "#d7d7d7";
export var aliasFieldBorderColorChecked = "#0a3142";
export var aliasFieldBackgroundColorBase = "#ffffff";
export var aliasFieldBackgroundColorError = "#e92326";
export var aliasFieldBackgroundColorActive = "#062430";
export var aliasFieldBackgroundColorFocus = "#0a3142";
export var aliasFieldBackgroundColorDisabled = "#ededed";
export var aliasFieldBackgroundColorChecked = "#0a3142";
export var aliasFieldTextChecked = "#ffffff";
export var aliasFieldShadowBase = "0 2px 4px rgba(0, 0, 0, .12)";
export var aliasFieldShadowActive = "inset 0 1px 5px 0 #000000";
export var aliasFieldShadowFocus = "0 0 0 3px #92d3ee";
export var aliasFieldShadowError = "0 0 0 3px #f97a7d";
export var colorBlackBase = "#000000";
export var colorBlue10 = "#e0f3ff";
export var colorBlue20 = "#ade2fe";
export var colorBlue30 = "#68c3f5";
export var colorBlue40 = "#2da2e3";
export var colorBlue50 = "#0280c6";
export var colorBlue60 = "#00649c";
export var colorBlue70 = "#004c75";
export var colorBlue80 = "#003958";
export var colorBlue90 = "#002d46";
export var colorBlue100 = "#00283d";
export var colorBlueLight = "#2da2e3";
export var colorBlueBase = "#0280c6";
export var colorBlueDark = "#00649c";
export var colorText10 = "#000000";
export var colorText20 = "#000000";
export var colorText30 = "#000000";
export var colorText40 = "#000000";
export var colorText50 = "#000000";
export var colorText60 = "#ffffff";
export var colorText70 = "#ffffff";
export var colorText80 = "#ffffff";
export var colorText90 = "#ffffff";
export var colorText100 = "#ffffff";
export var colorTextBlueLight = "#000000";
export var colorTextBlueBase = "#000000";
export var colorTextBlueDark = "#ffffff";
export var colorTextGreenLight = "#000000";
export var colorTextGreenBase = "#000000";
export var colorTextGreenDark = "#ffffff";
export var colorTextGreyLight = "#000000";
export var colorTextGreyBase = "#000000";
export var colorTextGreyDark = "#ffffff";
export var colorTextMarketingLight = "#ffffff";
export var colorTextMarketingBase = "#ffffff";
export var colorTextMarketingDark = "#ffffff";
export var colorTextPrimaryLight = "#ffffff";
export var colorTextPrimaryBase = "#ffffff";
export var colorTextPrimaryDark = "#ffffff";
export var colorTextRedLight = "#000000";
export var colorTextRedBase = "#000000";
export var colorTextRedDark = "#ffffff";
export var colorTextSecondaryLight = "#000000";
export var colorTextSecondaryBase = "#ffffff";
export var colorTextSecondaryDark = "#ffffff";
export var colorTextTertiaryLight = "#ffffff";
export var colorTextTertiaryBase = "#ffffff";
export var colorTextTertiaryDark = "#ffffff";
export var colorGreen10 = "#e0ffe0";
export var colorGreen20 = "#b2f9b4";
export var colorGreen30 = "#74eb76";
export var colorGreen40 = "#40d342";
export var colorGreen50 = "#1ab11d";
export var colorGreen60 = "#048907";
export var colorGreen70 = "#006402";
export var colorGreen80 = "#005a02";
export var colorGreen90 = "#003b01";
export var colorGreen100 = "#003601";
export var colorGreenLight = "#40d342";
export var colorGreenBase = "#1ab11d";
export var colorGreenDark = "#048907";
export var colorGrey10 = "#f3f4f4";
export var colorGrey20 = "#ededed";
export var colorGrey30 = "#d7d7d7";
export var colorGrey40 = "#b8b8b8";
export var colorGrey50 = "#919191";
export var colorGrey60 = "#696969";
export var colorGrey70 = "#474747";
export var colorGrey80 = "#2f2f2f";
export var colorGrey90 = "#212121";
export var colorGrey100 = "#1c1c1c";
export var colorGreyLight = "#b8b8b8";
export var colorGreyBase = "#919191";
export var colorGreyDark = "#696969";
export var colorMarketing10 = "#f2fbff";
export var colorMarketing20 = "#c1e8f8";
export var colorMarketing30 = "#92d3ee";
export var colorMarketing40 = "#6bbee0";
export var colorMarketing50 = "#4ba7cd";
export var colorMarketing60 = "#338eb4";
export var colorMarketing70 = "#217295";
export var colorMarketing80 = "#14536e";
export var colorMarketing90 = "#0a3142";
export var colorMarketing100 = "#062430";
export var colorMarketingLight = "#14536e";
export var colorMarketingBase = "#0a3142";
export var colorMarketingDark = "#062430";
export var colorPrimary10 = "#f2fbff";
export var colorPrimary20 = "#c1e8f8";
export var colorPrimary30 = "#92d3ee";
export var colorPrimary40 = "#6bbee0";
export var colorPrimary50 = "#4ba7cd";
export var colorPrimary60 = "#338eb4";
export var colorPrimary70 = "#217295";
export var colorPrimary80 = "#14536e";
export var colorPrimary90 = "#0a3142";
export var colorPrimary100 = "#062430";
export var colorPrimaryLight = "#14536e";
export var colorPrimaryBase = "#0a3142";
export var colorPrimaryDark = "#062430";
export var colorRed10 = "#ffebeb";
export var colorRed20 = "#fdb5b6";
export var colorRed30 = "#f97a7d";
export var colorRed40 = "#f2494c";
export var colorRed50 = "#e92326";
export var colorRed60 = "#dd070b";
export var colorRed70 = "#cd0003";
export var colorRed80 = "#b80003";
export var colorRed90 = "#a00003";
export var colorRed100 = "#870002";
export var colorRedLight = "#f97a7d";
export var colorRedBase = "#e92326";
export var colorRedDark = "#cd0003";
export var colorSecondary10 = "#fff5e4";
export var colorSecondary20 = "#f8dcab";
export var colorSecondary30 = "#eec274";
export var colorSecondary40 = "#e1a947";
export var colorSecondary50 = "#cf9226";
export var colorSecondary60 = "#b87b10";
export var colorSecondary70 = "#9a670c";
export var colorSecondary80 = "#7f5407";
export var colorSecondary90 = "#5f3d02";
export var colorSecondary100 = "#3d2700";
export var colorSecondaryLight = "#cf9226";
export var colorSecondaryBase = "#b87b10";
export var colorSecondaryDark = "#9a670c";
export var colorTertiary10 = "#ffe2e0";
export var colorTertiary20 = "#fcb5b4";
export var colorTertiary30 = "#f77e7c";
export var colorTertiary40 = "#f0504e";
export var colorTertiary50 = "#e72d2a";
export var colorTertiary60 = "#da1311";
export var colorTertiary70 = "#cb0e0b";
export var colorTertiary80 = "#b70e0c";
export var colorTertiary90 = "#a60805";
export var colorTertiary100 = "#940200";
export var colorTertiaryLight = "#cb0e0b";
export var colorTertiaryBase = "#b70e0c";
export var colorTertiaryDark = "#a60805";
export var colorWhiteBase = "#ffffff";
export var accordionItemTitleColor = "#0a3142";
export var avatarSquareBorderRadius = "4px";
export var bannerRootBorderRadius = "4px";
export var brandedHeadingRootColor = "#0a3142";
export var brandedHeadingRootBorderColor = "#0a3142";
export var brandedHeadingRootSpacingTop = "8px";
export var brandedHeadingRootSpacingBottom = "8px";
export var calendarRootDayPickerNavButtonBorderRadius = "4px";
export var calendarRootDayPickerDayBorderRadius = "4px";
export var checkboxIconContainerBorderRadius = "2px";
export var checkboxCheckedColor = "#ffffff";
export var checkboxCheckedBackground = "#0a3142";
export var choiceContentBorderRadius = "4px";
export var choiceBodyBorderRadius = "2px";
export var choiceInfoColor = "#2f2f2f";
export var choiceTitleColor = "#2f2f2f";
export var choiceCaptionColor = "#696969";
export var choiceCheckedInfoColor = "#062430";
export var choiceCheckedTitleColor = "#062430";
export var choiceCheckedBackground = "#f2fbff";
export var choiceCheckedBorderColor = "#0a3142";
export var choiceCheckedIconColor = "#ffffff";
export var choiceCheckedIconBackground = "#0a3142";
export var dialogRootBorderRadius = "4px";
export var imageWrapperBorderRadius = "0px";
export var linkTextBrandedColor = "#0a3142";
export var linkTextBrandedHoverColor = "#0a3142";
export var linkTextBrandedVisitedColor = "#14536e";
export var linkTextBrandedActiveColor = "#062430";
export var loaderColorBase = "#0a3142";
export var loaderColorLight = "#c1e8f8";
export var loaderXxLarge = "40px";
export var loaderXLarge = "32px";
export var loaderLarge = "28px"; // Mainly for ios

export var loaderMedium = "24px";
export var loaderSmall = "16px";
export var paperWrapperBorderRadius = "2px";
export var placeholderRootBorderRadius = "0px";
export var radioCheckedColor = "#0a3142";
export var stepCompletedNumberColor = "#ffffff";
export var stepCompletedNumberBackground = "#0a3142";
export var stepCompletedLineColor = "#0a3142";
export var stepCompletedLabelColor = "#0a3142";
export var switchCheckedColor = "#ffffff";
export var switchCheckedBackground = "#0a3142";
export var switchActiveBackground = "#062430";
export var tableRootBorderRadius = "4px";
export var tooltipContainerBorderRadius = "4px";
export var widelistRootBorderRadius = "4px";
export var shadow0 = "none";
export var shadow1 = "0 2px 4px rgba(0, 0, 0, .12)";
export var shadow2 = "0 2px 7px rgba(0, 0, 0, .28)";
export var shadow3 = "0 7px 14px rgba(0, 0, 0, .28)";
export var shadow4 = "0 14px 28px rgba(0, 0, 0, .28)";
export var shadowInset1 = "inset 0 1px 10px 0 rgba(0, 0, 0, .24)";
export var shadowInset2 = "inset 0 1px 15px 0 rgba(0, 0, 0, 0.28)";
export var zIndex100 = 100; // tooltip

export var zIndex200 = 200; // menu

export var zIndex300 = 300; // popover

export var zIndex400 = 400; // sticky content

export var zIndex500 = 500; // sheet

export var zIndex600 = 600; // modal backdrop

export var zIndex700 = 700; // modal sheet

export var zIndex800 = 800; // modal (dialog, alert, page, full screen)

export var zIndex900 = 900; // toast

export var gridBreakpointXSmall = "0px"; // Mobile (portrait) | Grid Fluid

export var gridBreakpointSmall = "480px"; // Mobile (landscape) | Grid Fluid

export var gridBreakpointMedium = "786px"; // Tablet (portrait) | Grid Fluid

export var gridBreakpointLarge = "1010px"; // Desktop (13inch) / Tablet (landscape) | Grid Fluid

export var gridBreakpointXLarge = "1440px"; // HD Desktop (15inch and up) | Grid Static: 1200

export var gridGutter = "16px";
export var gridWrapFluid = "calc(100% - 32px)"; // Mobile Grid Fluid

export var gridWrapStatic = "1200px"; // Desktop static

export var space1 = "2px";
export var space2 = "4px";
export var space3 = "8px";
export var space4 = "12px";
export var space5 = "16px";
export var space6 = "24px";
export var space7 = "32px";
export var space8 = "40px";
export var space9 = "48px";
export var space10 = "64px";
export var space11 = "96px";
export var motionDurationFast = "200ms";
export var motionDurationMedium = "300ms";
export var motionDurationSlow = "500ms";
export var motionDurationLoop = "1200ms";
export var overlayFill = "rgba(0, 0, 0, 0.33)";
export var overlayGradientLinearFadeToTop = "linear-gradient(-180deg, rgba(213, 219, 224, 0) 0%, rgba(0, 0, 0, 0.33) 100%)";
export var overlayGradientLinearFadeToBottom = "linear-gradient(-180deg, rgba(0, 0, 0, 0.33) 0%, rgba(255, 255, 255, 0) 100%)";
export var borderRadius0 = "0px";
export var borderRadius1 = "2px";
export var borderRadius2 = "4px";
export var borderRadius3 = "8px";
export var borderRadius4 = "12px";
export var borderRadius5 = "16px";
export var borderRadius6 = "24px";
export var borderRadius7 = "32px";
export var borderRadius8 = "40px";
export var borderRadius9 = "48px";
export var borderRadius10 = "64px";
export var borderRadius11 = "96px";
export var borderRadiusSides = "9999px";
export var borderRadiusFill = "50%";
export var fontCaption1Size = "14px";
export var fontCaption1LineHeight = "1.1429";
export var fontCaption2Size = "12px";
export var fontCaption2LineHeight = "1.3333";
export var fontHeading1Size = "28px"; // h1

export var fontHeading1LineHeight = "1.1429"; // h1

export var fontHeading1Weight = "700"; // h1

export var fontHeading1LargeSize = "40px"; // h1

export var fontHeading1LargeLineHeight = "1.1"; // h1

export var fontHeading2Size = "24px"; // h2

export var fontHeading2LineHeight = "1.1667"; // h2

export var fontHeading2Weight = "700"; // h2

export var fontHeading2LargeSize = "32px"; // h2

export var fontHeading2LargeLineHeight = "1.25"; // h2

export var fontHeading3Size = "22px"; // h3

export var fontHeading3LineHeight = "1.2727"; // h3

export var fontHeading3Weight = "700"; // h3

export var fontHeading3LargeSize = "24px"; // h3

export var fontHeading3LargeLineHeight = "1.3333"; // h3

export var fontHeading4Size = "20px"; // h4

export var fontHeading4LineHeight = "1.4"; // h4

export var fontHeading4Weight = "700"; // h4

export var fontHeading5Size = "18px"; // h5

export var fontHeading5LineHeight = "1.3333"; // h5

export var fontHeading5Weight = "700"; // h5

export var fontHeading6Size = "16px"; // h6

export var fontHeading6LineHeight = "1.25"; // h6

export var fontHeading6Weight = "700"; // h6

export var fontParagraphSize = "16px";
export var fontParagraphLineHeight = "1.5";
export var fontParagraphLargeSize = "16px";
export var fontParagraphLargeLineHeight = "1.5";
export var fontFamilyNuachtSansWeb = "'Nuacht Sans', 'Helvetica Neue', Arial, sans-serif";
export var fontFamilyNuachtSerifHeadlineWeb = "'Nuacht Serif Headline', Georgia, serif";
export var fontFamilyHalant = "Halant, 'Times New Roman', Times, serif";
export var fontFamilyProdukt = "Produkt, 'Times New Roman', Times, serif";
export var fontFamilyHelveticaLtStdCond = "Helvetica Neue Condensed, Arial, Helvetica, sans-serif";
export var fontFamilyHelveticaNeueLtStd = "HelveticaNeueLTStd, Arial, Helvetica, sans-serif";
export var fontFamilyVitesse = "Vitesse, 'Times New Roman', Times, serif";
export var fontFamilyBwModelica = "BwModelica, Open Sans, sans-serif";
export var fontFamilySofiaProCondensed = "Sofia Pro Condensed, Arial, Helvetica, sans-serif";
export var fontFamilyBarlowSemiCondensed = "BarlowSemiCondensed, Arial, Helvetica, sans-serif";
export var fontFamilyMerriweather = "Merriweather, 'Times New Roman', Times, serif";
export var fontFamilyGeorgia = "Georgia, serif";
export var fontFamilyOpenSans = "OpenSans, Arial, Helvetica, sans-serif";
export var fontFamilyMarkproNarrow = "Mark Pro Narrow, Open Sans, Arial, Helvetica, sans-serif";
export var fontFamilyFFGoodProWide = "FFGoodProWide, Open Sans, Arial, Helvetica, sans-serif";
export var fontFamilyFFGoodOtCondensed = "FFGoodOTCondensed, Open Sans, Arial, Helvetica, sans-serif";
export var fontFamilyBrandPrimary = "Georgia, serif"; // UI Display (e.g. section title)

export var fontFamilyBrandSecondary = "-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"; // Article Display (e.g. teaser title)

export var fontFamilySystem = "-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"; // UI Text (e.g. link text) -> body 1

export var fontSize6XLarge = "40px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize5XLarge = "32px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize4XLarge = "28px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize3XLarge = "24px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXxLarge = "22px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXLarge = "20px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeLarge = "18px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeMedium = "16px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeSmall = "14px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXSmall = "12px"; // use font.heading, font.paragraph, font.caption instead

export var fontWeightRegular = "400"; // normal

export var fontWeightMedium = "500"; // medium

export var fontWeightBold = "700"; // bold

export var lineHeight4XLarge = "48px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeight3XLarge = "44px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXxLarge = "40px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXLarge = "32px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightLarge = "28px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightMedium = "24px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightSmall = "20px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXSmall = "16px"; // use font.heading, font.paragraph, font.caption instead

export var buttonOutlineBorderColor = "#000000";
export var buttonOutlineColor = "#000000";
export var buttonOutlineHoverBorderColor = "#0a3142";
export var buttonOutlineHoverColor = "#0a3142";
export var buttonOutlineActiveBackground = "#f2fbff";
export var buttonOutlineActiveBorderColor = "#0a3142";
export var buttonOutlineActiveColor = "#0a3142";
export var buttonPlainColor = "#0a3142";
export var buttonPlainHoverBackground = "#f2fbff";
export var buttonPlainActiveBackground = "#c1e8f8";
export var buttonPrimaryBackground = "#0a3142";
export var buttonPrimaryColor = "#ffffff";
export var buttonPrimaryHoverBackground = "#14536e";
export var buttonPrimaryHoverColor = "#ffffff";
export var buttonPrimaryActiveBackground = "#062430";
export var buttonPrimaryActiveColor = "#ffffff";
export var buttonFontFamily = "Georgia, serif";
export var buttonFontWeight = "700";
export var buttonSecondaryColor = "#0a3142";
export var buttonRootFontWeight = "700";
export var iconXLarge = "32px";
export var iconLarge = "28px"; // Mainly for ios

export var iconMedium = "24px";
export var iconSmall = "16px";